<script lang="ts" setup>
import vPreloadImg from '@/ts/directives/v-preload-img.ts';
import model from '@/ts/model.ts';
import facebookImg from '@/assets/footer-facebook.svg';
import instagramImg from '@/assets/footer-instagram.svg';
import { computed } from 'vue';
const fbLink = computed(() => model.clientConfig.socialMedia?.facebook);
const instaLink = computed(() => model.clientConfig.socialMedia?.instagram);
</script>

<template>
    <div class="social-media" v-if="fbLink || instaLink" v-mobile>
        <template v-if="fbLink">
            <a :href="fbLink" target="_blank">
                <img v-preload-img="facebookImg">
            </a>
        </template>
        <template v-if="instaLink">
            <a :href="instaLink" target="_blank">
                <img v-preload-img="instagramImg">
            </a>
        </template>
    </div>
</template>

<style lang="scss" scoped>
    .social-media{
        display: flex;
        justify-content: center;
        align-items: center;
        flex: .25;
        &[data-mobile]{
            padding: 20px 0;
        }
    }
</style>